module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp23_6000.17d8b75a.png";